import DefaultParameters from './defaultParameters';
import { CRITICAL, MEDIUM, LOW } from '../congestionLevels';

const createTimeBasedCongestionLevel = (customParams = {}) => {
  const params = {
    ...DefaultParameters,
    ...customParams,
  };
  let dangerZone = false;
  let dangerZoneStart;
  return {
    getLevel({ audioPacketLoss }) {
      if (audioPacketLoss < params.packetLossCriticalThreshold) {
        dangerZone = false;
        return LOW;
      }

      const currentTime = Date.now();
      if (!dangerZone) {
        dangerZoneStart = currentTime;
        dangerZone = true;
      }

      if (currentTime > dangerZoneStart + params.criticalCongestionPeriod) {
        return CRITICAL;
      } else if (currentTime > dangerZoneStart + (params.criticalCongestionPeriod / 2)) {
        return MEDIUM;
      }

      return LOW;
    },
  };
};

export default createTimeBasedCongestionLevel;
